define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "./helpscoutActions", "../../models/UserContext", "../../models/HelpScoutConversationModel", "../../models/HelpScoutThreadModel"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, HelpScoutActions, UserContext, HelpScoutConversationModel, HelpScoutThreadModel) {
    "use strict";
    var HelpScout = /** @class */ (function () {
        function HelpScout() {
            this.canExport = UserContext.hasAccess("Admin");
            this.editHelpScoutConversation = ko.observable(new HelpScoutConversationModel());
            this.editHelpScoutThread = ko.observable(new HelpScoutThreadModel());
            this.userCanViewHelpScout = ko.observable(UserContext.hasAccess("Admin,HelpScout.View,HelpScout.Edit,HelpScout.Delete"));
            this.userCanEditHelpScout = ko.observable(UserContext.hasAccess("Admin,HelpScout.Edit,HelpScout.Delete"));
            this.userCanDeleteHelpScout = ko.observable(UserContext.hasAccess("Admin,HelpScout.Delete"));
            this.expandedHelpScoutThreadIDs = [];
            this.gridId = "divHelpScoutTable";
        }
        HelpScout.prototype.init = function () {
            var self = this;
            self.helpScoutActions = new HelpScoutActions();
            self.helpScoutActions.initHelpScout();
            var userLookup = self.helpScoutActions.getHelpScoutUsersLookup(true);
            // Get lookup data:
            var getLookupData = tools.ajaxGet({
                url: "/Support/GetConversationLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                }
            });
            $.when(getLookupData, userLookup).done(function () {
                $("#contextLoader").hide();
                $("#mainContext").show();
                //self.initHelpScoutConversations();
                self.helpScoutActions.getCustomers("Customers", self.helpScoutConversationTable);
                ko.applyBindings(self, document.getElementById("ko-main-content"));
                $("#Customers").on("change", function () {
                    self.hideContact();
                });
                $(".btn-create-con").on("click", function (event) {
                    self.helpScoutActions.editHelpScoutConversation(0, self.helpScoutConversationTable);
                    event.preventDefault();
                });
                $("#CustomerContacts, #Creator, #Owner").on("change", function () {
                    if (!self.helpScoutActions.clearInAction) {
                        setTimeout(function () {
                            self.helpScoutConversationTable.refresh();
                        });
                    }
                });
            });
        };
        HelpScout.prototype.initSearchBy = function () {
            var self = this;
            $("#page-title").text("Search By");
            self.helpScoutActions = new HelpScoutActions();
            self.helpScoutActions.initHelpScout();
            var userLookup = self.helpScoutActions.getHelpScoutUsersLookup(true);
            // Get lookup data:
            var getLookupData = tools.ajaxGet({
                url: "/Support/GetConversationLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                }
            });
            $.when(getLookupData, userLookup).done(function () {
                $("#contextLoader").hide();
                $("#mainContext").show();
                self.initSearchByGridOptions();
                self.helpScoutActions.getCustomers("Customers", self.helpScoutConversationTable);
                ko.applyBindings(self, document.getElementById("ko-main-content"));
                $("#Customers").on("change", function () {
                    setTimeout(function () {
                        if (self.helpScoutActions.filterByCustomerId() > 0) {
                            $("#ContactFilter").show();
                            self.helpScoutActions.getCustomerContacts(self.helpScoutActions.filterByCustomerId());
                        }
                        else {
                            $("#ContactFilter").hide();
                        }
                    });
                });
                $(".btn-create-con").on("click", function (event) {
                    self.helpScoutActions.editHelpScoutConversation(0, self.helpScoutConversationTable);
                    event.preventDefault();
                });
                $("#CustomerContacts, #Creator, #Owner").on("change", function () {
                    if (!self.helpScoutActions.clearInAction) {
                        setTimeout(function () {
                            self.helpScoutConversationTable.refresh();
                        });
                    }
                });
            });
        };
        HelpScout.prototype.initAssignedBy = function () {
            var self = this;
            $("#page-title").text("Assigned By");
            self.helpScoutActions = new HelpScoutActions();
            self.helpScoutActions.initHelpScout();
            var userLookup = self.helpScoutActions.getHelpScoutUsersLookup(true);
            // Get lookup data:
            var getLookupData = tools.ajaxGet({
                url: "/Support/GetConversationLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                }
            });
            $.when(getLookupData, userLookup).done(function () {
                $("#contextLoader").hide();
                $("#mainContext").show();
                self.initAssignedByGridOptions();
                ko.applyBindings(self, document.getElementById("ko-main-content"));
                $(".btn-create-con").on("click", function (event) {
                    self.helpScoutActions.editHelpScoutConversation(0, self.helpScoutConversationTable);
                    event.preventDefault();
                });
                $("#CustomerContacts, #Creator, #Owner").on("change", function () {
                    if (!self.helpScoutActions.clearInAction) {
                        setTimeout(function () {
                            self.helpScoutConversationTable.refresh();
                        });
                    }
                });
            });
        };
        HelpScout.prototype.initMyTickets = function () {
            var self = this;
            $("#page-title").text("My Tickets");
            self.helpScoutActions = new HelpScoutActions();
            self.helpScoutActions.initHelpScout();
            var userLookup = self.helpScoutActions.getHelpScoutUsersLookup(true);
            // Get lookup data:
            var getLookupData = tools.ajaxGet({
                url: "/Support/GetConversationLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                }
            });
            $.when(getLookupData, userLookup).done(function () {
                $("#contextLoader").hide();
                $("#mainContext").show();
                self.initMyTicketsGridOptions();
                ko.applyBindings(self, document.getElementById("ko-main-content"));
                $(".btn-create-con").on("click", function (event) {
                    self.helpScoutActions.editHelpScoutConversation(0, self.helpScoutConversationTable);
                    event.preventDefault();
                });
            });
        };
        HelpScout.prototype.initSearchByGridOptions = function () {
            var self = this;
            var gridStructure = self.lookupLists.GridStructures.HelpScoutConversationsStructure;
            var columns = gridStructure.columns;
            columns.push({
                field: "",
                title: "",
                width: "110px",
                sortable: false,
                template: function (dataItem) {
                    var html = '<div class="text-center">';
                    if (self.userCanEditHelpScout()) {
                        html += '<a class="btn btn-sm btn-default btn-hs-t-reply" href="#" title="Reply"><i class="fa fa-reply"></i></a>';
                        html += '&nbsp;<a class="btn btn-sm btn-info btn-hs-c-edit" href="#" title="Edit"><i class="fa fa-edit"></i></a>';
                    }
                    html += "</div>";
                    return html;
                }
            });
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Support/SearchConversationsBy",
                            type: "POST",
                            data: function () {
                                var data = {
                                    statusFilter: self.helpScoutActions.filterByHelpScoutStatus(),
                                    userId: self.helpScoutActions.filterByOwnerId()
                                };
                                if (self.helpScoutActions.filterByHelpScoutPeriod()) {
                                    data.periodFilter = self.helpScoutActions.filterByHelpScoutPeriod();
                                }
                                if (self.helpScoutActions.customersDropDownList) {
                                    if (self.helpScoutActions.customersDropDownList.value()) {
                                        data.customerId = self.helpScoutActions.customersDropDownList.value();
                                    }
                                }
                                if (self.helpScoutActions.filterByContactId()) {
                                    data.contactId = self.helpScoutActions.filterByContactId();
                                }
                                if (self.helpScoutActions.filterByAny()) {
                                    data.searchText = self.helpScoutActions.filterByAny();
                                }
                                if (self.helpScoutActions.filterByTag()) {
                                    data.searchTag = self.helpScoutActions.filterByTag();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    pageSize: 50,
                    serverSorting: false,
                    schema: {
                        model: gridStructure.model
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#searchby-toolbar-template").html()),
                    columns: columns,
                    resizable: true,
                    reorderable: true,
                    //mobile: true,
                    scrollable: false,
                    /*columnMenu: true,
                    filterable: {
                        mode: "row",
                        extra: false
                    },*/
                    detailInit: self.initHelpScoutThreads.bind(self),
                    dataBound: function (e) {
                        var gridData = e.sender;
                        $.each(gridData.tbody.find("tr.k-master-row"), function () {
                            var rowData = gridData.dataItem(this);
                            if (self.contains(self.expandedHelpScoutThreadIDs, rowData.Id)) {
                                gridData.expandRow(this);
                            }
                        });
                        $(gridData.tbody.find("tr.k-master-row .btn")).kendoTooltip({
                            position: "top"
                        }).data("kendoTooltip");
                    },
                    detailExpand: function (e) {
                        var rowData = e.sender.dataItem(e.masterRow);
                        if (!self.contains(self.expandedHelpScoutThreadIDs, rowData.Id)) {
                            self.expandedHelpScoutThreadIDs.push(rowData.Id);
                        }
                    },
                    detailCollapse: function (e) {
                        var rowData = e.sender.dataItem(e.masterRow);
                        for (var i = 0; i < self.expandedHelpScoutThreadIDs.length; i++) {
                            if (self.expandedHelpScoutThreadIDs[i] === rowData.Id)
                                self.expandedHelpScoutThreadIDs.splice(i, 1);
                        }
                    },
                    pageable: {
                        refresh: true,
                        pageSizes: false,
                        buttonCount: 5
                    }
                },
                gridId: self.gridId,
                showPagerOnTop: false,
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.initHelpScoutConversations(gridOptions);
        };
        HelpScout.prototype.initAssignedByGridOptions = function () {
            var self = this;
            var gridStructure = self.lookupLists.GridStructures.HelpScoutConversationsStructure;
            var columns = gridStructure.columns;
            columns.push({
                field: "",
                title: "",
                width: "110px",
                sortable: false,
                template: function (dataItem) {
                    var html = '<div class="text-center">';
                    if (self.userCanEditHelpScout()) {
                        html += '<a class="btn btn-sm btn-default btn-hs-t-reply" href="#" title="Reply"><i class="fa fa-reply"></i></a>';
                        html += '&nbsp;<a class="btn btn-sm btn-info btn-hs-c-edit" href="#" title="Edit"><i class="fa fa-edit"></i></a>';
                    }
                    html += "</div>";
                    return html;
                }
            });
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Support/GetAssignedBy",
                            type: "POST",
                            data: function () {
                                var data = {
                                    periodFilter: self.helpScoutActions.filterByHelpScoutPeriod(),
                                    statusFilter: self.helpScoutActions.filterByHelpScoutStatus(),
                                    userId: self.helpScoutActions.filterByOwnerId()
                                };
                                if (self.helpScoutActions.filterByTag()) {
                                    data.searchTag = self.helpScoutActions.filterByTag();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    pageSize: 50,
                    serverSorting: false,
                    schema: {
                        model: gridStructure.model
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#assignedby-toolbar-template").html()),
                    columns: columns,
                    resizable: true,
                    reorderable: true,
                    //mobile: true,
                    scrollable: false,
                    detailInit: self.initHelpScoutThreads.bind(self),
                    dataBound: function (e) {
                        var gridData = e.sender;
                        $.each(gridData.tbody.find("tr.k-master-row"), function () {
                            var rowData = gridData.dataItem(this);
                            if (self.contains(self.expandedHelpScoutThreadIDs, rowData.Id)) {
                                gridData.expandRow(this);
                            }
                        });
                        $(gridData.tbody.find("tr.k-master-row .btn")).kendoTooltip({
                            position: "top"
                        });
                    },
                    detailExpand: function (e) {
                        var rowData = e.sender.dataItem(e.masterRow);
                        if (!self.contains(self.expandedHelpScoutThreadIDs, rowData.Id)) {
                            self.expandedHelpScoutThreadIDs.push(rowData.Id);
                        }
                    },
                    detailCollapse: function (e) {
                        var rowData = e.sender.dataItem(e.masterRow);
                        for (var i = 0; i < self.expandedHelpScoutThreadIDs.length; i++) {
                            if (self.expandedHelpScoutThreadIDs[i] == rowData.Id)
                                self.expandedHelpScoutThreadIDs.splice(i, 1);
                        }
                    },
                    pageable: {
                        refresh: true,
                        pageSizes: false,
                        buttonCount: 5
                    }
                },
                gridId: self.gridId,
                showPagerOnTop: false,
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.initHelpScoutConversations(gridOptions);
        };
        HelpScout.prototype.initMyTicketsGridOptions = function () {
            var self = this;
            var gridStructure = self.lookupLists.GridStructures.HelpScoutConversationsStructure;
            var columns = gridStructure.columns;
            columns.push({
                field: "",
                title: "",
                width: "110px",
                sortable: false,
                template: function (dataItem) {
                    var html = '<div class="text-center">';
                    if (self.userCanEditHelpScout()) {
                        html += '<a class="btn btn-sm btn-default btn-hs-t-reply" href="#" title="Reply"><i class="fa fa-reply"></i></a>';
                        html += '&nbsp;<a class="btn btn-sm btn-info btn-hs-c-edit" href="#" title="Edit"><i class="fa fa-edit"></i></a>';
                    }
                    html += "</div>";
                    return html;
                }
            });
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Support/GetMyTickets",
                            type: "POST",
                            data: function () {
                                var data = {
                                    periodFilter: self.helpScoutActions.filterByHelpScoutPeriod(),
                                    statusFilter: self.helpScoutActions.filterByHelpScoutStatus()
                                };
                                if (self.helpScoutActions.filterByTag()) {
                                    data.searchTag = self.helpScoutActions.filterByTag();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    pageSize: 50,
                    serverSorting: false,
                    schema: {
                        model: gridStructure.model
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#mytickets-toolbar-template").html()),
                    columns: columns,
                    resizable: true,
                    reorderable: true,
                    //mobile: true,
                    scrollable: false,
                    detailInit: self.initHelpScoutThreads.bind(self),
                    dataBound: function (e) {
                        var gridData = e.sender;
                        $.each(gridData.tbody.find("tr.k-master-row"), function () {
                            var rowData = gridData.dataItem(this);
                            if (self.contains(self.expandedHelpScoutThreadIDs, rowData.Id)) {
                                gridData.expandRow(this);
                            }
                        });
                        var tooltip = $(gridData.tbody.find("tr.k-master-row .btn")).kendoTooltip({
                            position: "top"
                        }).data("kendoTooltip");
                    },
                    detailExpand: function (e) {
                        var rowData = e.sender.dataItem(e.masterRow);
                        if (!self.contains(self.expandedHelpScoutThreadIDs, rowData.Id)) {
                            self.expandedHelpScoutThreadIDs.push(rowData.Id);
                        }
                    },
                    detailCollapse: function (e) {
                        var rowData = e.sender.dataItem(e.masterRow);
                        for (var i = 0; i < self.expandedHelpScoutThreadIDs.length; i++) {
                            if (self.expandedHelpScoutThreadIDs[i] == rowData.Id)
                                self.expandedHelpScoutThreadIDs.splice(i, 1);
                        }
                    },
                    pageable: {
                        refresh: true,
                        pageSizes: false,
                        buttonCount: 5
                    }
                },
                gridId: self.gridId,
                showPagerOnTop: false,
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.initHelpScoutConversations(gridOptions);
        };
        HelpScout.prototype.initHelpScoutConversations = function (gridOptions) {
            var self = this;
            self.helpScoutConversationTable = new KendoUtils.KendoUtils();
            self.helpScoutConversationTable.initGrid(gridOptions);
            $("#" + self.gridId + " tbody").on("click", ".btn-hs-t-reply", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.helpScoutActions.editHelpScoutThread(data.Id, data.Subject, data.OwnerId, self.helpScoutConversationTable);
                event.preventDefault();
            }).on("click", ".btn-hs-c-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.helpScoutActions.editHelpScoutConversation(data.Id, self.helpScoutConversationTable);
                event.preventDefault();
            });
            self.helpScoutActions.filterByHelpScoutStatus.extend({ rateLimit: 200 }).subscribe(function () {
                if (!self.helpScoutActions.clearInAction) {
                    self.helpScoutConversationTable.refresh();
                }
            });
            self.helpScoutActions.filterByHelpScoutPeriod.extend({ rateLimit: 200 }).subscribe(function () {
                if (!self.helpScoutActions.clearInAction) {
                    self.helpScoutConversationTable.refresh();
                }
            });
            self.helpScoutActions.filterByAny.extend({ rateLimit: 500 }).subscribe(function () {
                if (!self.helpScoutActions.clearInAction) {
                    self.helpScoutConversationTable.refresh();
                }
            });
            self.helpScoutActions.filterByTag.extend({ rateLimit: 500 }).subscribe(function () {
                if (!self.helpScoutActions.clearInAction) {
                    self.helpScoutConversationTable.refresh();
                }
            });
        };
        HelpScout.prototype.initHelpScoutThreads = function (e) {
            var self = this;
            var gridStructure = self.lookupLists.GridStructures.HelpScoutThreadStructure;
            var grid = $("<div/>").appendTo(e.detailCell).kendoGrid({
                dataSource: {
                    transport: {
                        read: {
                            url: "/Support/GetHelpScoutConversationThreads",
                            type: "POST",
                            data: function () {
                                var data = {
                                    conversationId: e.data.Id
                                };
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                        data: function (response) { return response.Data; },
                        total: "Total",
                        aggregates: "Aggregates",
                        errors: "Errors"
                    },
                    serverPaging: false,
                    serverSorting: false
                },
                scrollable: false,
                resizable: true,
                sortable: false,
                pageable: false,
                columns: [{
                        field: "",
                        template: $("#thread-template").html()
                    }],
                dataBound: function (event) {
                    var items = event.sender.dataItems();
                    if (items && items.length > 0) {
                        var firstItem = items[0];
                        e.data["OwnerName"] = firstItem.AssignToName;
                        e.data["OwnerId"] = firstItem.AssignToId;
                        self.helpScoutConversationTable.redrawRow(e.masterRow);
                        $(".thead-date").kendoTooltip({
                            position: "right"
                        });
                    }
                }
            }).data("kendoGrid");
            $(".k-grid tbody .k-grid .k-grid-header").hide();
        };
        HelpScout.prototype.contains = function (a, obj) {
            for (var i = 0; i < a.length; i++) {
                if (a[i] === obj)
                    return true;
            }
            return false;
        };
        HelpScout.prototype.clearFilter = function () {
            var self = this;
            self.helpScoutActions.clearFilter();
            self.hideContact();
            setTimeout(function () {
                self.helpScoutConversationTable.refresh();
            });
        };
        HelpScout.prototype.hideContact = function () {
            var self = this;
            setTimeout(function () {
                if (self.helpScoutActions.filterByCustomerId() > 0) {
                    $("#ContactFilter").show();
                    self.helpScoutActions.getCustomerContacts(self.helpScoutActions.filterByCustomerId());
                }
                else {
                    $("#ContactFilter").hide();
                }
            });
        };
        return HelpScout;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Support/Index")) {
            log.log("Initialize HelpScout list");
            $(function () {
                (new HelpScout()).init();
            });
        }
        else if (urls_1.urls.startsWith("/Support/MyTickets")) {
            log.log("Initialize my tickets list");
            $(function () {
                (new HelpScout()).initMyTickets();
            });
        }
        else if (urls_1.urls.startsWith("/Support/AssignedBy")) {
            log.log("Initialize assigned tickets list");
            $(function () {
                (new HelpScout()).initAssignedBy();
            });
        }
        else if (urls_1.urls.startsWith("/Support/SearchBy")) {
            log.log("Initialize search tickets list");
            $(function () {
                (new HelpScout()).initSearchBy();
            });
        }
    }, 0);
    return HelpScout;
});
//# sourceMappingURL=helpscout.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/helpscout/helpscout.js
// module id = 274
// module chunks = 2